// extracted by mini-css-extract-plugin
module.exports = {"languageTab":"LanguageTab_languageTab__3QMOs","active":"LanguageTab_active__2LMMg"};